import { render, staticRenderFns } from "./CoEditForm.vue?vue&type=template&id=7f28a420&scoped=true"
import script from "./CoEditForm.vue?vue&type=script&lang=js"
export * from "./CoEditForm.vue?vue&type=script&lang=js"
import style0 from "./CoEditForm.vue?vue&type=style&index=0&id=7f28a420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28a420",
  null
  
)

export default component.exports